
document.addEventListener('DOMContentLoaded', function () {
	const links = document.querySelectorAll('.menu-item > a');
	const header = document.querySelector('header.header_h_layout8');

	links.forEach((link) => {
		link.addEventListener('mouseenter', () => {
			header.classList.add('hover-from-link');
		});

		link.addEventListener('mouseleave', () => {
			header.classList.remove('hover-from-link');
		});
	});

	window.addEventListener('scroll', () => {
		if (window.scrollY > 50) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});
});

function syncMenuVisibility() {
	const menuWrappers = document.querySelectorAll('.side-menu-wrapper .menu-main');

	menuWrappers.forEach((menu) => {
		const openItem = menu.querySelector('.menu-item.has-submenu.show');
		const isOpen = Boolean(openItem);
		const items = menu.querySelectorAll('.menu-item');

		menu.classList.toggle('submenu-open', isOpen);

		items.forEach((item) => {
			const shouldHide = isOpen && item !== openItem;
			const submenu = item.querySelector('.fs_submenu');

			item.classList.toggle('submenu-hidden', shouldHide);
			if (shouldHide) {
				item.setAttribute('aria-hidden', 'true');
				item.hidden = true;
				item.style.display = 'none';
			} else {
				item.removeAttribute('aria-hidden');
				item.hidden = false;
				item.style.display = '';
			}

			if (submenu) {
				const submenuVisible = item.classList.contains('show') && !shouldHide;
				submenu.hidden = !submenuVisible;
				submenu.style.display = submenuVisible ? '' : 'none';
				if (!submenuVisible) {
					submenu.setAttribute('aria-hidden', 'true');
				} else {
					submenu.removeAttribute('aria-hidden');
				}
			}
		});
	});
}

document.querySelectorAll('.menu-item.has-submenu').forEach((item) => {
	item.addEventListener('click', () => {
		document.querySelectorAll('.menu-item.has-submenu').forEach((i) => i.classList.remove('show'));
		item.classList.add('show');
		syncMenuVisibility();
	});
});

document.querySelectorAll('.menu-item.has-submenu .submenu-close-btn').forEach((btn) => {
	btn.addEventListener('click', function (e) {
		e.stopPropagation();
		const menuItem = this.closest('.menu-item.has-submenu');
		if (menuItem && menuItem.classList.contains('show')) {
			menuItem.classList.remove('show');
			syncMenuVisibility();
		}
	});
});

function closeAllSubmenusIfWide() {
	if (window.innerWidth >= 836) {
		document.querySelectorAll('.menu-item.show').forEach((item) => {
			item.classList.remove('show');
		});
	}
	syncMenuVisibility();
}

syncMenuVisibility();
closeAllSubmenusIfWide();
window.addEventListener('resize', closeAllSubmenusIfWide);
